import type { ReactElement } from "react";
import type { Location } from "react-router";
import { useLocation, useNavigate } from "react-router";

interface ReactRouterAdapterProps {
    children: (helpers: {
        location: Location;
        push: (location: { search: string; state?: unknown }) => void;
        replace: (location: { search: string; state?: unknown }) => void;
    }) => ReactElement | null;
}

export default function ReactRouterAdapter({
    children,
}: ReactRouterAdapterProps) {
    const navigate = useNavigate();
    const location = useLocation();

    const push = (newLocation: { search: string; state?: unknown }) => {
        navigate({ search: newLocation.search }, { state: newLocation.state });
    };

    const replace = (newLocation: { search: string; state?: unknown }) => {
        navigate(
            { search: newLocation.search },
            {
                replace: true,
                state: newLocation.state,
            },
        );
    };

    return children({
        location,
        push,
        replace,
    });
}
